import { render, staticRenderFns } from "./WordSeparatorListTable.vue?vue&type=template&id=44390d15&scoped=true&lang=html&"
import script from "./WordSeparatorListTable.vue?vue&type=script&lang=js&"
export * from "./WordSeparatorListTable.vue?vue&type=script&lang=js&"
import style0 from "./WordSeparatorListTable.vue?vue&type=style&index=0&id=44390d15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44390d15",
  null
  
)

export default component.exports